/**
 * raund内で利用するAPIのURLを定義
 * */
export const raundUrl = {
  campaign: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/campaign`,
  presents: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/presents`,
  sheets: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/sheets`,
  user: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user`,
  /** DELETE */
  userStamps: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/stamps`,
  /** GET /api/v1/user/sheets */
  userSheets: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/sheets`,
  /***/
  stamps: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/stamps`,
  /**  */
  coupons: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/coupons`,
  /**
   * GET /api/v1/presents/{presentId}のAPI
   * POST /api/v1/presents/{presentId}のAPI
   * */
  presentItemId: ({ presentId }: { presentId: number }) =>
    `${process.env.NEXT_PUBLIC_API_URL}/api/v1/presents/${presentId}`,
  /**
   * GET api/v1/user/presents/{user_present_id}のAPI
   * DELETE api/v1/user/presents
   * */
  userPresents: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/presents`,
  /** GET & POST /api/v1/user/present/item/${userPresentId} ※似ているAPIがあるので非常に注意すること */
  userPresentItemId: ({ userPresentId }: { userPresentId: number }) =>
    `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/present/item/${userPresentId}`,
  /** GET & POST /api/v1/user/present/${userPresentId}/item ※似ているAPIがあるので非常に注意すること*/
  userPresentIdItem: ({ userPresentId }: { userPresentId: number }) =>
    `${process.env.NEXT_PUBLIC_API_URL}/api/v1/user/present/${userPresentId}/item`,
  spots: ({ id, latitude, longitude }: { id: number; latitude?: string; longitude?: string }) => {
    const url = `${process.env.NEXT_PUBLIC_API_URL}/api/v1/spots`
    if (latitude && longitude) {
      return `${url}/${id}?lat=${latitude}&lon=${longitude}`
    }
    return `${url}/${id}`
  },
  /** GET */
  notifications: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/notifications`,
  /** GET, POST */
  questionnairesAnswerType: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/questionnaires/answer/type`,
  /** GET /api/v1/questionnaires/type/1 or /api/v1/questionnaires/type/2 */
  questionnairesType: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/questionnaires/type`,
  /** POST /api/v1/inquiry/1/result */
  inquiry: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/inquiry`,
  /** GET /api/v1/menus */
  menu: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/menus/`,
  /** GET /api/v1/photos */
  photo: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/photo`,
  /** POST /api/v1/photo */
  photos: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/photos`,
  /** GET /api/v1/photo/check */
  photoCheck: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/photo/check`,
  pointHistory: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/point_history`,
  restore: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/account/restore`,
  authCheck: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/auth/check`,
  tracking: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/tracking`,
  changeForcePassword: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/change-forced-password/`,
  register: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/register`,
  login: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/login`,
  refresh: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/refresh`,
  ocrUpload: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/ocr`,
  ocrStampRequest: `${process.env.NEXT_PUBLIC_API_URL}/api/v1/ocr/stamp/request`,
}
